export default "__VITE_ASSET__oDc4ax8l__"